export const animationCreate = () => {
  if (typeof window !== "undefined") {
    import("wowjs").then(({ WOW, default: WOWDefault }) => {
      const Ctor = WOW || (WOWDefault as any)?.WOW || WOWDefault;
      if (typeof Ctor === "function") {
        new Ctor({ live: false }).init();
      }
    });
  }
};
